// extracted by mini-css-extract-plugin
export default {"hola_trobber":"hola_trobber___npNpo"};